<template>
    <div id="agent-listing-add" class="agent-listing-add">
        <b-form @submit="onSubmit">
            <b-col xl="10" lg="11" md="12">
                <b-form-group label="Listing Address" label-cols="3"
                              breakpoint="md" horizontal>
                    <autocomplete name="address" placeholder="Search by Address"
                                  v-model="autocomplete.address.item"
                                  :component-item="autocomplete.address.template"
                                  :items="autocomplete.address.items"
                                  :get-label="addressGetlabel"
                                  :autoSelectOneItem="false"
                                  :min-len="autocomplete.address.minLength"
                                  @change="addressInputChanged"
                                  @item-selected="addressItemSelected"
                                  @update-items="addressUpdate" required>
                    </autocomplete>
                </b-form-group>

                <b-form-group label="Listing Type" label-cols="3">
                    <b-form-select v-model="listing_type_id" :options="options"></b-form-select>
                </b-form-group>

                <b-form-group label="Cooperating Commission" label-cols="3">
                    <b-input v-model="commission"></b-input>
                    <small class="form-text text-muted">Enter the commission amount as a whole number, i.e. 3 for 3%</small>
                </b-form-group>

                <b-button type="submit" variant="primary">Submit</b-button>
            </b-col>
        </b-form>

        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>

import addressTemplate from './autocomplete/templates/address_template'

export default {
    name: 'agent-listing-add',
    props: {
        agent: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            options: [
                { value: null, text: 'Please select a Listing Type' },
                { value: 1, text: 'Listing Agent'},
                { value: 2, text: 'Buyer\'s Agent'},
            ],
            autocomplete: {
                address: {
                    item: null,
                    items: [],
                    minLength: 3,
                    selected: false,
                    template: addressTemplate
                },
            },
            commission: null,
            event: "",
            editing: true,
            isLoading: false,
            listing: {
                ListingKey: null,
                UnparsedAddress: null,
            },
            listing_type_id: null
        }
    },
    created () {

    },
    methods: {
        //support autocomplete for customer email
        addressGetlabel(item) {
            return item ? item.UnparsedAddress : '';
        },
        addressInputChanged(text) {
            this.listing.UnparsedAddress = text;
        },
        addressItemSelected(item) {
            if (item) {
                this.listing.ListingKey = item.ListingKey;
            }
        },
        addressUpdate(text) {
            let _self = this;
            if (text.length > 3) {
                let _self = this;
                _self.isLoading = true;
                axios.get('/api/search/address', {params: {keywords: text}})
                    .then(function (response) {
                        _self.isLoading = false;
                        _self.autocomplete.address.items = $.map(response.data, function (dataItem) {
                            dataItem = dataItem.StandardFields;
                            return {
                                ListingKey: dataItem.ListingKey,
                                UnparsedAddress: dataItem.UnparsedAddress,
                                MlsStatus: dataItem.MlsStatus
                            };
                        });
                    });
            }
        },
        onSubmit() {
            let _self = this;
            _self.isLoading = true;
            let data = {
                agent: _self.agent,
                listing: _self.listing,
                listing_type_id: _self.listing_type_id,
                commission: _self.commission
            };
            axios.post('/api/agents/addListing', data)
                .then(function (response) {
                    _self.isLoading = false;
                    if (response.data.status === false) {
                        _self.$eventHub.$emit('app::message', 'error', 'Error', response.data.message);
                    } else {
                        _self.$eventHub.$emit('listing::added', "success");
                    }
                });
        }
    },
}

</script>
